(function ($) {
  $(function () {
    const heroSwiper = new Swiper(".js-hero-swiper", {
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      pagination: {
        el: ".js-hero-dots",
        clickable: true,
      },
      navigation: {
        prevEl: ".js-hero-prev",
        nextEl: ".js-hero-next",
      },
      autoplay: {
        delay: 5000,
      },
    });

    const heroSwiperMobil = new Swiper(".js-hero-swiper-mobil", {
      loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      pagination: {
        el: ".js-hero-dots",
        clickable: true,
      },
      allowTouchMove: false,
    });

    heroSwiper.controller.control = heroSwiperMobil;

    const imageTextSwiper = new Swiper(".js-image-text-slider", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        prevEl: ".js-text-image-slider-prev",
        nextEl: ".js-text-image-slider-next",
      },
      pagination: {
        el: ".js-image-text-slider-dots",
        clickable: true,
      },
    });

    if ($(".js-project-hero-slider").length !== 0) {
      let menu = [];
      const slides = $(".js-project-hero-slider").find(".swiper-slide");

      if (slides.length) {
        slides.each(function (index, element) {
          menu.push($(element).data("tabname"));
        });
      }

      const projectHeroSwiper = new Swiper(".js-project-hero-slider", {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + menu[index] + "</span>";
          },
        },
      });
    }

    const quotesSwiper = new Swiper(".js-quotes-slider", {
      loop: true,
      navigation: {
        prevEl: ".js-quote-slider-prev",
        nextEl: ".js-quote-slider-next",
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
        },
        1199: {
          slidesPerView: 2,
          spaceBetween: 64,
        },
      },
    });

    const imageGallerySwiper = $(".js-gallery-images-slider");
    imageGallerySwiper.slick({
      infinite: true,
      arrows: true,
      mobileFirst: true,
      prevArrow: $(".js-gallery-images-prev"),
      nextArrow: $(".js-gallery-images-next"),
      responsive: [
        {
          breakpoint: 300,
          settings: {
            slidesToShow: 1.65,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2.7,
          },
        },
      ],
    });

    $(".js-video-slider").slick({
      infinite: false,
      slidesToShow: 2,
      arrows: true,
      prevArrow: $(".js-videos-prev"),
      nextArrow: $(".js-videos-next"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".js-testimonials-slider").slick({
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      prevArrow: $(".js-testimonials-prev"),
      nextArrow: $(".js-testimonials-next"),
    });    
    
    $(".js-qualifications-slider").slick({
      infinite: false,
      slidesToShow: 4,
      arrows: true,
      prevArrow: $(".js-qualifications-prev"),
      nextArrow: $(".js-qualifications-next"),
      dots: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });

    $(".js-gallery-slider").slick({
      infinite: true,
      slidesToShow: 3,
      centerMode: true,
      centerPadding: "227px",
      arrows: true,
      prevArrow: $(".js-gallery-prev"),
      nextArrow: $(".js-gallery-next"),
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: "64px",
            slidesToShow: 1,
            arrows: false,
          },
        },
      ],
    });

    heroSwiper.on("slideChangeTransitionEnd", function (e) {
      if ($(".swiper-slide-active").find("video").length != 0) {
        $(".swiper-slide video").get(0).play();
        heroSwiper.autoplay.stop();

        $(".swiper-slide video").on("ended", function () {
          heroSwiper.slideNext();
          heroSwiper.autoplay.start();
        });
      }
    });
  });
})(jQuery);
